import { CIcon } from '~/icons/types'

export const ciOutboardMotor: CIcon = {
  width: '40',
  height: '40',
  paths: [
    {
      d:
        'M29.115 13.83c.8 0 1.454-.655 1.454-1.454 0-.8-.654-1.454-1.454-1.454H9.49c-.8 0-1.454.654-1.454 1.454 0 .8.654 1.454 1.454 1.454.436 1.308.872 4.288 2.69 4.288h14.174c1.817 0 2.326-2.98 2.762-4.288Zm-3.343 2.47h-2.69c-.218 0-.364-.145-.364-.363s.146-.363.364-.363h2.69c.218 0 .363.145.363.364.073.217-.145.363-.364.363Zm-11.85 18.103c0 1.381 1.163 2.544 2.544 2.544s2.18-1.163 2.544-2.544l4.434-15.555h-9.522v15.555ZM8.398 29.75c0 .727.655 1.381 1.382 1.381h3.343V28.37H9.78c-.8 0-1.382.582-1.382 1.381Zm-3.128-.73c-.072-.145-.218-.363-.363-.436.582-1.89 1.745-4.798.145-5.815-.654-.364-1.453-.364-2.035 0-1.599 1.017-.363 3.925.146 5.815-.364.29-.582.654-.582 1.163 0 .436.218.872.582 1.163-.582 1.89-1.745 4.798-.146 5.815.654.364 1.454.364 2.035 0 1.6-1.017.364-3.925-.145-5.815.145-.145.29-.29.364-.436h2.398c-.072-.218-.145-.436-.145-.727 0-.218.073-.509.145-.727H5.271Zm31.402-14.973c-1.526.219-2.544.437-3.125.727-.073 0-.073.073-.146.146H29.55c-.073.436-.218.8-.364 1.236-.072.218-.218.508-.29.726h4.579l.073.073c.581.29 1.599.582 3.125.727 1.527.218 1.454-3.852 0-3.634ZM29.115 5.69c0-1.454-1.236-2.69-2.69-2.69h-3.416l-2.617 4.434c-.582 1.018-2.108.145-1.527-.872L20.973 3h-1.672l-2.616 4.434c-.582 1.018-2.108.145-1.527-.872L17.266 3h-1.6L13.05 7.434c-.581 1.018-2.108.145-1.526-.872L13.632 3h-1.454c-1.454 0-2.69 1.236-2.69 2.69v4.434h19.627V5.69Z',
      fill: 'currentColor',
      fillRule: 'evenodd',
      clipRule: 'evenodd'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'outboard-motor',
  type: 'regular'
}
